/**
 * @flow
 * @relayHash b3f993cd6bf05f7f43519eba249a7304
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DonateVcInput = {
  userId: string,
  charityId: string,
  vc: number,
  clientMutationId?: ?string,
};
export type DonateVcMutationVariables = {|
  input: DonateVcInput
|};
export type DonateVcMutationResponse = {|
  +donateVc: ?{|
    +user: ?{|
      +vcCurrent: ?number
    |}
  |}
|};
export type DonateVcMutation = {|
  variables: DonateVcMutationVariables,
  response: DonateVcMutationResponse,
|};
*/


/*
mutation DonateVcMutation(
  $input: DonateVcInput!
) {
  donateVc(input: $input) {
    user {
      vcCurrent
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DonateVcInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DonateVcInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vcCurrent",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "DonateVcMutation",
  "id": null,
  "text": "mutation DonateVcMutation(\n  $input: DonateVcInput!\n) {\n  donateVc(input: $input) {\n    user {\n      vcCurrent\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DonateVcMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "donateVc",
        "storageKey": null,
        "args": v1,
        "concreteType": "DonateVcPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DonateVcMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "donateVc",
        "storageKey": null,
        "args": v1,
        "concreteType": "DonateVcPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '08391d46590e2b37a0c845905fa8abc2';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/DonateVcMutation.graphql.js